<template>
  <div id="app" class="app-container">
    <div class="main-header" v-if="$route.query.header">
      <div class="header-left" @click="toIndex"><</div>
      <div class="header-title">{{ $route.meta.title ? $route.meta.title : title }}</div>
    </div>
    <div class="fake-header" v-if="$route.query.header"></div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  data() {
    var title = ''
    if (this.userInfo.app) {
      title = this.userInfo.app.title
    }
    return {
      title: title
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    toIndex() {
      this.$router.replace({ name: 'Index' })
    }
  }
}
</script>

<style lang="scss">
@import './assets/style/base.scss';
</style>
<style lang="scss" scoped>
  @import './assets/style/const.scss';
  .main-header {
    position: fixed;
    top: 0;
    height: 40px;
    width: 375px;
    background: #fff;
    z-index: 100;
    text-align: center;
    border-bottom: 1px solid $color-purple;
    .header-left {
      position: absolute;
      left: 0;
      font-size: 18px;
      width: 40px;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
    }
    .header-title {
      font-size: 12px;
      height: 40px;
      line-height: 40px;
      width: 300px;
      margin: 0 auto;
      text-align: center;
    }
  }
  // 增加一个空头部，将页面其他部分的内容挤下去
  .fake-header {
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue